import clsx from 'clsx';
import React from 'react';
import styles from './StubAuthRequired.module.scss';
import Link from 'next/link';

const StubAuthRequired: React.FC = () => (
    <div className={styles.container}>
        <h2 className={styles.header}>Авторизуйтесь для получения доступа</h2>
        <div className={styles.body}>
            <div className={styles.textBlock}>
                <p>
                    Для доступа к информации,
                    <Link href="/auth/login">
                        <a>{' войдите '}</a>
                    </Link>
                    в личный кабинет.
                </p>
                <p>
                    Не зарегистрированы? Регистрация на нашей платформе проходит
                    быстро и легко. Никаких дополнительных документов не
                    требуется!
                </p>
                <p>
                    Присоединяйтесь к нам, это займет всего несколько минут, и
                    откроет новые возможности для вашего бизнеса!
                </p>
            </div>
            <Link href="/auth/registration">
                <a className={styles.link}>Зарегистрироваться</a>
            </Link>
        </div>
    </div>
);

export default StubAuthRequired;
